import { isValidSportradar } from '~/utilities/elements/isValidSportradar';
import { SPORTRADAR_TEAM_IDS } from '~/constants/SPORTRADAR_TEAM_IDS';

export const getSportradarTeamId = (
  customVertical: string,
  customTopic: string
) => {
  const isValid = isValidSportradar(customVertical, customTopic);

  if (!isValid) {
    return [];
  }

  const vertical = customVertical.toLowerCase();
  const topic = customTopic.toLowerCase().replace(/ /g, '-');
  const widgetId = 'us.team.';

  if (vertical.includes('ncaa')) {
    const ncaaf = SPORTRADAR_TEAM_IDS.ncaaf[topic] || null;
    const ncaab = SPORTRADAR_TEAM_IDS.ncaab[topic] || null;
    const widgets = [];

    if (ncaaf) {
      widgets.push({
        widgetId: `${widgetId}ncaaf.recentGames`,
        teamId: ncaaf,
      });
    }
    if (ncaab) {
      widgets.push({
        widgetId: `${widgetId}ncaab.recentGames`,
        teamId: ncaab,
      });
    }

    return widgets;
  }

  const id = SPORTRADAR_TEAM_IDS[vertical][topic];

  return [
    {
      widgetId: `${widgetId}${vertical}.recentGames`,
      teamId: id,
    },
  ];
};
